import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=2548193a&scoped=true"
import script from "./ColorBar.vue?vue&type=script&lang=js"
export * from "./ColorBar.vue?vue&type=script&lang=js"
import style0 from "./ColorBar.vue?vue&type=style&index=0&id=2548193a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548193a",
  null
  
)

export default component.exports